module.exports = __webpack_public_path__ + "static/img/hexibanner5.4481f7f9.jpg";